import React from 'react';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContentText from '@material-ui/core/DialogContentText';

export default props => {
  return (
    <React.Fragment>
      <DialogTitle id="max-width-dialog-title">
        Partner Payment Only
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          X where, <br />X = Number of agents with non-zero Partner Payment
          within the past 30 days of selected date
        </DialogContentText>
      </DialogContent>
    </React.Fragment>
  );
};
